import axios from "axios";
import TokenService from "./TokenService";

// Cria uma instância do Axios configurada
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // URL base da API
  timeout: 30000, // Tempo limite de 5 segundos
  headers: {
    "Content-Type": "application/json",
  },
});

// Lista de rotas que não precisam de refresh token
const publicRoutes = ['/user/login', '/user/refresh-token'];

// Função para redirecionar para login
const redirectToLogin = () => {
  TokenService.clearToken();
  sessionStorage.removeItem("user");
  window.location.href = '/';
};

// Interceptador de requisição para adicionar o token de autorização
api.interceptors.request.use(
  async (config) => {
    try {
      // Não tenta refresh token para rotas públicas
      if (config.url && publicRoutes.some(route => config.url?.includes(route))) {
        const token = TokenService.getToken();
        if (token && config.headers) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      }

      // Para outras rotas, tenta refresh token
      const token = await TokenService.refreshTokenIfNeeded();
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    } catch (error) {
      console.error('Erro no interceptador de requisição:', error);
      redirectToLogin();
      return Promise.reject(error);
    }
  },
  (error) => Promise.reject(error)
);

// Interceptador de resposta para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      // Erro de rede ou timeout
      console.error('Erro de conexão:', error);
      return Promise.reject(new Error('Erro de conexão com o servidor'));
    }

    const originalRequest = error.config;

    // Trata erro de autenticação
    if (error.response.status === 401) {
      // Não tenta refresh token para rotas públicas
      if (originalRequest.url && publicRoutes.some(route => originalRequest.url.includes(route))) {
        return Promise.reject(error);
      }

      if (originalRequest._retry) {
        redirectToLogin();
        return Promise.reject(new Error('Sessão expirada'));
      }

      try {
        originalRequest._retry = true;
        const newToken = await TokenService.refreshTokenIfNeeded();

        if (newToken) {
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          return api(originalRequest);
        }

        redirectToLogin();
        throw new Error('Falha ao renovar sessão');
      } catch (refreshError) {
        redirectToLogin();
        return Promise.reject(refreshError);
      }
    }

    // Outros erros HTTP
    const errorMessage = error.response.data?.message || 'Ocorreu um erro na requisição';
    return Promise.reject(new Error(errorMessage));
  }
);

export default api;
